module.exports = __webpack_public_path__ + "img/premium.74235ced.png";